import { PropsWithChildren, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import companyClosedLogo from "assets/sidebarClosedLogo.svg";
import companyOpenedLogo from "assets/sidebarOpenedLogo.svg";
import { LanguageSwitch, Menu, UserSettings } from "legacyNext/components";

import { S } from "./dashboard-layout.styles";

export const DashboardLayout = (props: PropsWithChildren) => {
    const { children } = props;
    const { t } = useTranslation();
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    return (
        <S.Layout isCollapsed={isCollapsed}>
            <S.Navigation isCollapsed={isCollapsed}>
                <S.CloseButton onClick={toggleCollapse}>
                    <S.CloseButtonIcon isCollapsed={isCollapsed} />
                    {!isCollapsed && (
                        <S.CloseButtonText>
                            {t("legacyNext.closePanel", "Close panel")}
                        </S.CloseButtonText>
                    )}
                </S.CloseButton>
                <S.Logo>
                    <Link to="/next">
                        <img
                            src={
                                isCollapsed
                                    ? companyClosedLogo
                                    : companyOpenedLogo
                            }
                            alt="Legacy"
                        />
                    </Link>
                </S.Logo>
                <Menu isCollapsed={isCollapsed} />
            </S.Navigation>
            <S.Body>
                <S.Header>
                    <LanguageSwitch />
                    <UserSettings />
                </S.Header>
                <S.Content>{children}</S.Content>
            </S.Body>
        </S.Layout>
    );
};
